












































import Login from '@/components/common/Login.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    Login,
  },
})
export default class Nav extends Vue {
  public isActive = false;
  public showBlog = process.env.VUE_APP_BLOG_ENABLED === 'true';

  public toggle() {
    this.isActive ? this.hide() : this.show();
  }

  public show() {
    this.isActive = true;
  }

  public hide() {
    this.isActive = false;
  }

  @Watch('$route')
  public onRouteChange() {
    this.hide();
  }
}
